import type { LinkedAccount } from '../../bank-account-fields.types';

const formatAccount = (account: Record<string, unknown>): LinkedAccount => {
  const balances = (account.balances as Record<string, unknown>) || {};

  return {
    accountId: account.accountId || null,
    balances: {
      available: balances?.available || null,
      balanceDate: balances?.balanceDate || null,
      currency: balances?.currency || null,
      current: balances?.current || null,
      limit: balances?.limit || null,
    },
    isClosed: account.isClosed || null,
  } as LinkedAccount;
};

export default formatAccount;
